<div class="content">
  <div class="title-div">
    <div class="orders-title">
      <span class="heading-left">Projects</span>
    </div>
  </div>

  <project-filters 
    [filterSettings]="filterSettings"
    (filterSettingsChanged)="updateProjects()">
  </project-filters>

  <div class="projects-list-wrapper">
    <div *ngIf="loadingProjects || loadingHotToggle" class="projects-loading-overlay" role="status" aria-live="polite" aria-label="Loading projects">
      <div class="projects-loading-message">
        <span class="material-icons history-icon">update</span>
        <span>Loading...</span>
      </div>
    </div>

    <div *ngFor="let project of projects" style="margin-bottom: 10px;">
      <project-card 
        [projectData]="project" 
        [canSelectProject]="true" 
        [selectedProject]="selectedProject" 
        (selectedProjectChange)="selectedProject = $event" 
        (hotToggleLoadingChange)="loadingHotToggle = $event"
        (projectNamesDuplicated)="refreshProjectCards($event)"
        [showViewIcons]="true"
        [viewVisible]="selectedView"
        (selectedViewChange)="selectedViewChanged($event)"></project-card>
          <div *ngIf="selectedProject === project && selectedView !== ProjectCardView.None" style="margin-left:10px; margin-top: 10px;">
            <div *ngIf="selectedView === ProjectCardView.OrderDetails">
              <div *ngIf="loadingOrderDetails; else orderDetailsLoaded" class="order-details-loading-message">
                <span class="material-icons order-details-loading-icon">update</span>
                <span>Loading order details<span class="order-details-loading-dots">{{ loadingOrderDetailsDots }}</span></span>
              </div>
              <ng-template #orderDetailsLoaded>
                <div *ngIf="orderDetailsError; else orderDetailsAvailable" class="order-details-error-message">
                  Failed to load order details.
                </div>
                <ng-template #orderDetailsAvailable>
                  <div *ngIf="orderDetails; else noOrderDetails">
                    <div class="order-details-filter">
                      <input
                        type="text"
                        placeholder="Filter"
                        [(ngModel)]="orderDetailsFilterText" />
                    </div>
                    <order-object-viewer
                      [object]="orderDetails"
                      [filterText]="orderDetailsFilterText"
                      [showFriendly]="showFriendlyorderDetails"
                      [autoExpand]="true"
                      [hideTopLevelName]="true"
                      [propertyDisplayConfig]="orderDetailsPropertyDisplayConfig"></order-object-viewer>
                  </div>
                </ng-template>
                <ng-template #noOrderDetails>
                  <h2>No order details available...</h2>
                </ng-template>
              </ng-template>
            </div>
            <div *ngIf="selectedView === ProjectCardView.EngineeringCalculations">
              <div *ngIf="loadingProjectSaves; else projectSavesLoaded">
                <p>Loading project saves...</p>
              </div>
              <ng-template #projectSavesLoaded>
                <div class="engineering-saves-toolbar">
                  <button
                    class="generate-calculations-button"
                    type="button"
                    (click)="generateCalculations()"
                    [disabled]="generatingProjectCalculations"
                  >
                    {{ generatingProjectCalculations ? 'Generating...' : 'Generate Calcuations' }}
                  </button>
                </div>
                <div *ngIf="projectSaves.length > 0; else noSaves">
                <div class="engineering-saves-table-wrapper">
                  <table class="engineering-saves-table">
                    <thead class="engineering-saves-table-head">
                      <tr>
                        <th></th>
                        <th>Calculation Type</th>
                        <th>Name</th>
                        <th>Created</th>
                        <th>Last Modified</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let save of projectSaves">
                        <td>
                          <span
                            *ngIf="hasToolRoute(save)"
                            class="material-icons general-action-icon new-window-icon"
                            (click)="openToolSave(save)"
                            title="Open Engineering Calculation in New Tab"
                          >open_in_new</span>
                        </td>
                        <td>{{ formatToolType(save.Type) }}</td>
                        <td>{{ save.Name }}</td>
                        <td>{{ save.Created | date:'short' }}</td>
                        <td>{{ save.LastModified | date:'short' }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                </div>
              </ng-template>
              <ng-template #noSaves>
                <h2>No engineering calculations available...</h2>
              </ng-template>
            </div>
            <div *ngIf="selectedView === ProjectCardView.EngineeringDetails">
              Eng Details
            </div>
            <div *ngIf="selectedView === ProjectCardView.Schedule">
              <master-schedule-calendar 
                [showNewWindowIcon]="true" 
                [project]="project?.ProjectNumber" 
                [projectData]="project" 
                [allProjectsData]="projects" 
                [filterSettings]="filterSettings"
                [firstDateLeadInDays]="5"></master-schedule-calendar>
            </div>
            <div *ngIf="selectedView === ProjectCardView.Documents">
              Documents
            </div>
          </div>
      </div>
    </div>
  </div>
